import { WindowSettings, PanelHooksEditor2D } from "@dextall/panel-hooks-editor-2d";
import { PanelEditorContent } from "../../../panels/panel-editor-scope";

type Props = PanelEditorContent & {
    windowSettings: WindowSettings;
    louvreSettings: WindowSettings;
};

export const PanelEditor2D = ({
    panelDefinition,
    selection,
    windowSettings,
    louvreSettings,
    hooks,
    setComponentSelection,
    updateHook,
    addHook,
    removeHook,
}: Props) => {
    return (
        <PanelHooksEditor2D
            panelDefinition={panelDefinition}
            hooks={hooks}
            windowSettings={windowSettings}
            louvreSettings={louvreSettings}
            selection={selection}
            onSelectionChange={setComponentSelection}
            onHookAdded={addHook}
            onHookChanged={updateHook}
            onHookRemoved={removeHook}
        />
    );
};
